import { useState, useEffect, useMemo } from 'react';

const MOBILE_MEDIA = '(max-width: 768px)';

// Video playback mode is fixed for the trans lander — we autoplay all step
// videos. The original create-friend had a GB flag here to A/B test
// AUTOMATIC / MOUSEOVER / OFF modes; we don't need that variation.
const ANIMATION_MODE = 'AUTOMATIC';

export const useVideoAnimation = () => {
  const isTouchDevice = useMemo(() => {
    if (typeof window === 'undefined') return false;

    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      /android|iphone|ipad|ipod/i.test(navigator.userAgent)
    );
  }, []);

  const [isMobileViewport, setIsMobileViewport] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(MOBILE_MEDIA).matches;
  });

  useEffect(() => {
    const media = window.matchMedia(MOBILE_MEDIA);
    const handler = (e) => setIsMobileViewport(e.matches);
    media.addEventListener('change', handler);
    return () => media.removeEventListener('change', handler);
  }, []);

  const isMobile = isTouchDevice && isMobileViewport;

  const getVideoProps = () => ({
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true,
    preload: 'auto',
  });

  return {
    animationMode: ANIMATION_MODE,
    isMobile,
    isTouchDevice,
    isMobileViewport,
    shouldAutoPlay: true,
    shouldPlayOnHoverOrSelected: false,
    shouldShowVideos: true,
    getVideoProps,
  };
};
